<template>
	<div>
		<el-dialog
			title="导入结果"
			:visible.sync="dialogVisible"
			width="500px"
		>
			<span>导入失败，请点击下载导入结果并检查失败原因，完成修改后重新导入</span>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="confirmBtnFun">下载导入结果</el-button>
        <el-button @click="cancelBtnFun">取消</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
export default {
	data() {
		return {
			dialogVisible: false,
		}
	},
  methods: {
    // 打开弹框
    opendDialog (downloadId) {
      this.downloadId = downloadId
      this.dialogVisible = true
    },
    // 取消弹框
    cancelBtnFun () {
      this.dialogVisible = false
    },
    // 确认
    confirmBtnFun () {
      this.downloadImportResult()
    },
    // 下载导入结果
    downloadImportResult() {
      // let url = `/autoapp-default-server-recovery/api/oldMachineRecovery/downLoadInboundFailInfo/${this.downloadId}`
      let url = `/autoapp-default-server-recovery/api/jd/recycle/order/downLoadInboundFailInfo/${this.downloadId}`
      let title = '导入失败结果'
      this.global.exportExcel(url, {}, title).catch((res) => {
        let blob = new Blob([res.response.data], {
          type: 'application/json',
        });
        var blobReader = new Response(blob).json()
        blobReader.then((res) => {
          this.$message.error(res.message)
        })
      })
      this.dialogVisible = false
    }
  },
}
</script>
<style scoped lang="scss">
.dialog-footer{
  padding: 16px;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/views/jdOldMachineRecycleManage/components/ResDialog.vue